import {Component, Input, Output, EventEmitter} from '@angular/core';

/**
 * Generated class for the AutoKeywordComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'auto-keyword',
  templateUrl: 'auto-keyword.html'
})
export class AutoKeywordComponent {


  @Input() auto_keyword;

  @Output() toggleSwitch = new EventEmitter();
  @Output() toggleVague = new EventEmitter();
  @Output() onDelete = new EventEmitter();

  constructor() {
    console.log('Hello AutoKeywordComponent Component');
  }

  onChangeSwitch(e){
    e.stopPropagation();
    this.toggleSwitch.emit(this.auto_keyword);
  }

  onChangeVague(e){
    e.stopPropagation();
    this.toggleVague.emit(this.auto_keyword);
  }

  onDeleteKeyword(e){
    e.stopPropagation();
    this.onDelete.emit(this.auto_keyword);
  }




}





// WEBPACK FOOTER //
// ./src/components/auto-keyword/auto-keyword.ts